import { GalleryAccessLevel, GalleryDto, GalleryFeedbackOption } from '@picflow/types';
import { captureException } from '@sentry/angular-ivy';
import { allFeedbackOptions, planPermissions } from '../consts';
import { Plan } from '../types/plan.type';
import { Product } from '../types/product.type';
import { toCamelCase } from './to-camel-case';

export const getAllowedFeedbackOptions = (
  gallery: GalleryDto,
  plan: Plan,
  accessLevel: GalleryAccessLevel
): GalleryFeedbackOption[] => {
  if (accessLevel === 'view_only' || accessLevel === 'no_access') return [];
  const permissions = getPermissions(gallery, plan);
  return allFeedbackOptions.filter(option => {
    return permissions.asset[toCamelCase(option) + 's'];
  });
};

export const getAllowedAndEnabledFeedbackOptions = (
  gallery: GalleryDto,
  plan: Plan,
  accessLevel: GalleryAccessLevel
): GalleryFeedbackOption[] => {
  if (accessLevel === 'view_only' || accessLevel === 'no_access') return [];
  const permissions = getPermissions(gallery, plan);
  return gallery.enabled_feedback_options.filter(option => {
    return permissions.asset[toCamelCase(option) + 's'];
  });
};

const getPlanName = (gallery: GalleryDto, plan?: Plan) => {
  if (gallery?.tenant_product_name) return gallery.tenant_product_name;
  if (plan) {
    const galleryTenantId = gallery['tenant']?.id || gallery['tenant'];
    if (plan.tenantId !== galleryTenantId) return;
    return `Picflow ${plan.product.name}`;
  }
};

export const getStorageForProduct = (product: Product) => {
  return planPermissions[`Picflow ${product.name}`]?.storage;
};

export const getMemberCountForProduct = (product: Product) => {
  return planPermissions[`Picflow ${product.name}`].maxTenantSeats;
};

export const getPermissions = (gallery: GalleryDto, plan?: Plan) => {
  const planName = getPlanName(gallery, plan);
  if (!planName) {
    captureException('no-plan-name');
    console.log('no plan name', gallery, plan);
    return planPermissions['Picflow Free']?.permissions;
  }

  const permissions = planPermissions[planName]?.permissions;
  if (!permissions) throw 'No permissions for plan: ' + planName;

  return permissions;
};
